import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/tariff/tariff.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TariffListCurrencyCell } from './tariff-list-currency.cell';
import { TariffListCurrencyHeader } from './tariff-list-currency.header';

export const TariffListCurrencyColumn: IdentifiedColumnDef<
  TariffModel,
  TariffModel['currency']
> = {
  enableSorting: false,
  header: TariffListCurrencyHeader,
  cell: TariffListCurrencyCell,
};
